/**
 * Firestore 데이터베이스 컬렉션 이름 상수 정의
 */
export const COLLECTIONS = {
    // 1. 교재 및 학습자료 관련 컬렉션
    BOOKS: 'books',                       // 교재 기본 정보
    BOOK_CHAPTER_SET: 'bookChapterSet',   // 단원 세트 (ChapterSet)
    BOOK_UNIT: 'bookUnit',               // 개별 학습 페이지 (Unit)
    BOOK_QUESTIONS: 'bookQuestions',       // 개별 학습 문항
    BOOK_QUESTION_SETS: 'bookQuestionSets', // 문항 세트

    // 2. 구성원 관리
    MEMBERS: 'members',                   // 학생 및 회원 정보
    TEACHERS: 'teachers',                 // 선생님 프로필 정보
    TEACHER_APPLICATIONS: 'teacherApplications', // 강사 채용 지원서 정보

    // 3. 학생 학습 및 활동 데이터
    STUDENT_SCHEDULES: 'studentSchedules', // 학생 스케줄/계획
    SCHEDULE_MARKERS: 'schedule_markers',  // 스케줄 진도 마커
    STUDENT_EXAMS: 'studentExams',         // 학생 성적/시험 기록
    STUDENT_COUNSEL: 'studentCounsel',     // 학생 상담 일지
    STUDENT_QA: 'studentQA',               // 실시간 AI 질의응답 (Q&A)

    // 4. 시스템 및 콘텐츠 운영 데이터
    RECORDS: 'records',                   // 각종 기록 데이터
    NOTICES: 'notices',                   // 공지사항
    INQUIRIES: 'inquiries',               // 문의사항
    SUCCESS_STORIES: 'successStories',     // 합격수기/우수사례
    ACADEMY_LIFE: 'academy-life',         // 학원 생활 정보
    REVIEWS: 'reviews',                   // 리뷰 및 후기
    MANUALS: 'manuals',                   // 매뉴얼/사용 가이드
    LOGS: 'logs',                         // 시스템 작업 로그
    MAIN_BANNERS: 'mainBanners'           // 메인 홈페이지 배너
} as const;

export type CollectionType = typeof COLLECTIONS[keyof typeof COLLECTIONS];
